export interface HydratedUrlFilters<TFilters, TRouteFilter = undefined> {
  filterValues: TFilters;
  routeFilter: TRouteFilter;
  hasValidUrlFilters: boolean;
  canonicalSearch: string;
}

export const getCsvValues = (params: URLSearchParams, key: string): string[] =>
  params
    .getAll(key)
    .flatMap((value) => value.split(','))
    .map((value) => value.trim())
    .filter(Boolean);

export const uniqueValues = (values: string[]): string[] =>
  Array.from(new Set(values));

export const isSafeOptionValue = (value: string, maxLength = 255): boolean =>
  value.length > 0 &&
  value.length <= maxLength &&
  /^[A-Za-z0-9][A-Za-z0-9._:/@ +()-]*$/.test(value);

export const getPositiveIntegerValues = (values: string[]): string[] =>
  uniqueValues(
    values.filter((value) => {
      if (!/^\d+$/.test(value)) return false;
      const parsed = Number(value);
      return Number.isSafeInteger(parsed) && parsed > 0;
    }),
  );

export const getValidTimestamp = (value: string | null): number | null => {
  if (value === null || value.trim() === '') return null;

  const timestamp = Number(value);
  if (!Number.isFinite(timestamp)) return null;

  const date = new Date(timestamp);
  return Number.isFinite(date.getTime()) ? timestamp : null;
};

export const isValidDateValue = (value: unknown): value is Date =>
  value instanceof Date && Number.isFinite(value.getTime());

export const toCanonicalSearch = (params: URLSearchParams): string => {
  const value = params.toString();
  return value ? `?${value}` : '';
};

export const replaceBrowserSearch = (canonicalSearch: string): void => {
  if (window.location.search === canonicalSearch) return;

  window.history.replaceState(
    window.history.state,
    '',
    `${window.location.pathname}${canonicalSearch}${window.location.hash}`,
  );
};
